const normalizeText = (value) => String(value || '').trim();

const getChildName = (entry = {}) => normalizeText(
  entry.childName || entry.personName || entry.careRecipientName
);

export const getMedicationReviewClarification = (entry = {}) => {
  const metadata = entry?.metadata || {};
  const changeReview = metadata.medicationReview;
  const entryKind = normalizeText(entry.kind || entry.type || entry.category).toLowerCase();
  const reviewReasons = Array.isArray(metadata.reviewReasons) ? metadata.reviewReasons : [];
  const hasMedicationChangeReviewReason = reviewReasons.some((reason) => (
    /medication.*needs.review|new.medication.*review/i.test(normalizeText(reason))
  ));
  if (changeReview) {
    return changeReview.status === 'pending' ? 'Confirm this medication change.' : '';
  }
  if (['medication', 'medication_change', 'meds'].includes(entryKind) && hasMedicationChangeReviewReason) {
    return 'Confirm this medication change.';
  }

  const administrationReview = metadata.medicationAdministrationReview;
  if (administrationReview?.status !== 'pending') return '';

  if (!administrationReview.medicationId) {
    const childName = getChildName(entry);
    return `Match this mention to ${childName ? `${childName}’s` : 'the'} medication list.`;
  }

  const administrationReasons = [
    ...reviewReasons,
    ...(Array.isArray(administrationReview.reviewReasons) ? administrationReview.reviewReasons : []),
  ];
  return administrationReasons.some((reason) => /schedule|time/i.test(normalizeText(reason)))
    ? 'Confirm which medication schedule this refers to.'
    : 'Confirm this medication administration.';
};

export default getMedicationReviewClarification;
